import { zxcvbnOptions } from '../../Options';
export default (match) => {
    let warning = zxcvbnOptions.translations.warnings.extendedRepeat;
    if (match.baseToken.length === 1) {
        warning = zxcvbnOptions.translations.warnings.simpleRepeat;
    }
    return {
        warning,
        suggestions: [zxcvbnOptions.translations.suggestions.repeated],
    };
};
//# sourceMappingURL=feedback.js.map